
import { isObject , isArray }  from "./types"

const leafElementList = [
    // "ve-select"
    "00000000-0000-0000-0000-000000000009",
    //"ve-boolean"
    "00000000-0000-0000-0000-000000000007",
    // "ve-date"
    "00000000-0000-0000-0000-000000000006",
    // "ve-time"
    "00000000-0000-0000-0000-000000000005",
    // "ve-float"
    "00000000-0000-0000-0000-000000000004",
    // "ve-integer"
    "00000000-0000-0000-0000-000000000003",
    // "ve-textarea"
    "00000000-0000-0000-0000-000000000002",
    // "ve-input"
    "00000000-0000-0000-0000-000000000001",
    // "ve-map"
    "00000000-0000-0000-0000-000000100002",
    // "ve-audio"
    "00000000-0000-0000-0000-000000100003",
    // "ve-file"
    "00000000-0000-0000-0000-000000100004",
    // "ve-image"
    "00000000-0000-0000-0000-000000100005",
    // "ve-video"
    "00000000-0000-0000-0000-000000100006",
    // "ve-scanner"
    "00000000-0000-0000-0000-000000100007",
    // "ve-timestamp"
    "00000000-0000-0000-0000-000000000010",
    // "ve-sku"
    "00000000-0000-0000-0000-000000100012",
    // "ve-batch"
    "00000000-0000-0000-0000-000000100001",
    
    // "Operator"
    "00000000-0000-0000-0000-000000100019",

    // "Email"
    "00000000-0000-0000-0000-000000100017",

    // "WebLink"
    "00000000-0000-0000-0000-000000100018",

    // "Params"
    "00000000-0000-0000-0000-000000100013",

    // "RichText"
    "00000000-0000-0000-0000-000000100020"
]

const preContainerList = [
    /// custom
    "00000000-0000-0000-0000-000000100011", 
    /// base
    "00000000-0000-0000-0000-000000100010"
]
const ObjectElementType = "00000000-0000-0000-0000-000000000011"
const ListElementType = "00000000-0000-0000-0000-000000000008"

class TemplateSpaceObject {

    public type: string
    public key: string
    public keypath: string
    public zhlabel: string
    public enlabel: string
    public visible: boolean
    public value: string
    public spaceList: Array<TemplateSpaceObject>

    constructor(type:string, key: string, keypath: string, zhlabel: string, enlabel: string, visible: boolean, value: any, spaceList: Array<TemplateSpaceObject>) {
        this.type = type
        this.key = key
        this.keypath = keypath
        this.zhlabel = zhlabel
        this.enlabel = enlabel
        this.visible = visible
        this.value = value
        this.spaceList = spaceList
    }
}

export const formatterTemplate = (templateJson: any) => {

    let attributes = templateJson.modelDetail.model.attributes
    let languageObj = templateJson.languageDetail.language

    let spaceList: Array<TemplateSpaceObject> = []
    let collector: Array<TemplateSpaceObject> = []
    attributes.forEach((item: any) => {
        formatElement(item, spaceList, templateJson, collector, languageObj)
    })
    return collector
}

/// formatElement 
/// 打平模版, 找到所有的叶子结点及其深度.
function formatElement(object: any, spaceList: Array<TemplateSpaceObject>, templateJson: any, collector: Array<TemplateSpaceObject>, language: any) {

    const elementType = object.type
    if(leafElementList.includes(elementType)){
        
        let keypath = spaceList.map((item: TemplateSpaceObject)=>{ return item.key }).join('.')
        let key = object.key || ""
        let zhlabel = findLang(language, key,'zh-CN') || (object.displayReference && object.displayReference.label)
        let enlabel = findLang(language, key,'en-US') || (object.displayReference && object.displayReference.label)
        let visible = object.displayReference.visible
        let type = elementType
        let spList = JSON.parse(JSON.stringify(spaceList))
        collector.push(new TemplateSpaceObject(type, key, keypath, zhlabel, enlabel,visible, undefined, spList)) 

    } else if (elementType === ListElementType) {

        let keypath = spaceList.map((item: TemplateSpaceObject)=>{ return item.key }).join('.')
        let key = object.key || ""
        let zhlabel = findLang(language, key,'zh-CN') || (object.displayReference && object.displayReference.label)
        let enlabel = findLang(language, key,'en-US') || (object.displayReference && object.displayReference.label)
        let visible = object.displayReference.visible
        let type = elementType
        let spList = JSON.parse(JSON.stringify(spaceList))
        let nextSpList = JSON.parse(JSON.stringify(spaceList))
        nextSpList.push(new TemplateSpaceObject(type, key, keypath, zhlabel, enlabel, visible, undefined, spList))

        formatElement(object.dataReference.itemType,nextSpList, templateJson, collector, language)

    } else {

        let keypath = spaceList.map((item: TemplateSpaceObject)=>{ return item.key }).join('.')
        let key = object.key || ""
        let zhlabel = findLang(language, key,'zh-CN') || (object.displayReference && object.displayReference.label)
        let enlabel = findLang(language, key,'en-US') || (object.displayReference && object.displayReference.label)
        let type = elementType
        let spList: Array<TemplateSpaceObject> = JSON.parse(JSON.stringify(spaceList))
        let nextSpList = JSON.parse(JSON.stringify(spaceList))
        let visible = object.displayReference.visible

        nextSpList.push(new TemplateSpaceObject(type, key, keypath, zhlabel, enlabel, visible, undefined, spList))

        let attributes = object.dataReference.attributes
        if(!attributes || attributes.length <= 0){
            let remoteElement = findTemplate(templateJson, object.type)

            if(remoteElement || preContainerList.includes(elementType)){
                let keypath = spList.map((item: TemplateSpaceObject)=>{ return item.key }).join('.')
                let key = object.key || ""
                let visible = object.displayReference.visible
                let zhlabel = remoteElement.name
                let enlabel = remoteElement.name
                let type = elementType
                let nextSpList = JSON.parse(JSON.stringify(spaceList))
                collector.push(new TemplateSpaceObject(type, key, keypath, zhlabel, enlabel, visible, undefined, nextSpList))
            }
        }else{
        
            attributes.forEach((item: any) => {
                formatElement(item,nextSpList, templateJson, collector, language)
            })
        }
    }
}

/**
 * 
 * @param language language json
 * @param key find key
 * @param lang language code , zh-CN / en-US
 * @returns localized label
 */
const findLang = (language: any, key: string, lang: string) => {
    
    if(!language || !language[lang]) {
        return undefined
    }

    let zhLang = language['zh-CN'] && {...language['zh-CN'].base, ...language['zh-CN'].custom} || {}
    let enLang = language['en-US'] && {...language['en-US'].base, ...language['en-US'].custom} || {}
    if(lang == 'zh-CN'){
        return zhLang[key] && zhLang[key].label
    }else{
        return enLang[key] && enLang[key].label
    }
}

/// 找到非本地存在的模版
/**
 * 
 * @param templateJson template json
 * @param type dcu type string
 * @returns 
 */
const findTemplate = (templateJson: any, type: string) => {
    let referenceList = templateJson.modelDetail.referenceList
    let template = referenceList.filter((item: any) => {
        return item.uuid == type
    })
    return template && JSON.parse(template[0].value)
}

/**
 * @param templateJson  template
 * @param depth 校验深度
 * @param existList 既有已解析list
 * @param datamodel 已有datamodel数据
 * @returns 待处理, 待渲染元素对象
 */
 export const mapTemplate = (templateJson: any, depth: number, existList: Array<any>, datamodel: Object) => {

    let attributes = JSON.parse(JSON.stringify(templateJson.modelDetail.model.attributes))
    let languageObj = templateJson.languageDetail && JSON.parse(JSON.stringify(templateJson.languageDetail.language)) || undefined

    let spaceList: any = []
    let config = {
        templateJson,
        language: languageObj,
        datamodel,
        existList
    }
    let replementator = attributes.map((item: any) => {
       return mapElement(item, spaceList, config, undefined)
    })
    return replementator
}

/// mapElement 
/// 遍历模版, 找到所有的叶子结点及其深度.
function mapElement(object: any, spaceList: any, config: any, listValue: any) {

    let { templateJson, language, datamodel, existList } = config

    const elementType = object.type
    /// list 类型的复杂处理
    if(leafElementList.includes(elementType)){
        
        let keypath = spaceList.map((item: any)=>{ return item.key }).join('.')
        let key = object.key || ""
        let zhlabel = findLang(language, key,'zh-CN') || (object.displayReference && object.displayReference.label)
        let enlabel = findLang(language, key,'en-US') || (object.displayReference && object.displayReference.label)
        let type = elementType
        let visible = object.displayReference.visible
        let spList = JSON.parse(JSON.stringify(spaceList))
        let value: any;
        if(listValue != undefined) {
            value = listValue[key] || listValue
        }else{
            value = findValue(keypath + "." + key, datamodel)
        }
        if(elementType == '00000000-0000-0000-0000-000000000009'){
            // console.log("element_", object)
            console.log("value", value)
            let options = object.controlReference && object.controlReference.options
            if(isArray(value)){
                value = value.map((item: any) => {
                    let op = options.filter((o: any) => {
                        return o.value == item
                    }) 
                    return op.length > 0 ? op[0].label : item
                })
            }else{
                let op = options.filter((o: any) => {
                    return o.value == value
                }) 
                op.length > 0 ? value = op[0].label : void 0;
            }
        }

        let exist = existList.filter((item: string) => {
            return (keypath + '.' + key).startsWith(item)
        })

        if(exist.length && exist.length > 0) {
            return undefined
        }

        let templateSpaceObj = new TemplateSpaceObject(type, key, keypath, zhlabel, enlabel, visible, value, spList)
        return templateSpaceObj

    } else if (elementType === ListElementType) {

        let keypath = spaceList.map((item: any)=>{ return item.key }).join('.')
        let key = object.key || ""
        let zhlabel = findLang(language, key,'zh-CN') || (object.displayReference && object.displayReference.label)
        let enlabel = findLang(language, key,'en-US') || (object.displayReference && object.displayReference.label)
        let visible = object.displayReference.visible
        let type = elementType
        let spList = JSON.parse(JSON.stringify(spaceList))
        let nextSpList = JSON.parse(JSON.stringify(spaceList))

        let templateSpaceObj = new TemplateSpaceObject(type, key, keypath, zhlabel, enlabel, visible, undefined, spList)
        nextSpList.push(templateSpaceObj)
        
        let exist = existList.filter((item: string) => {
            return (keypath + '.' + key).startsWith(item)
        })

        if(exist.length && exist.length > 0) {
            return undefined
        }

        let value = findValue(keypath + "." + key, datamodel)
        if(value && value.length > 0 && isArray(value)){
            
            value = value.map((val: any) => {
                return mapElement(object.dataReference.itemType,nextSpList, config, val)
            })
            value = value.filter((item: any) => {
                return item != undefined
            })

            return new TemplateSpaceObject(type, key, keypath, zhlabel, enlabel, visible, value, spList)
        }
    } else {

        let keypath = spaceList.map((item: any)=>{ return item.key }).join('.')
        let key = object.key || ""
        let zhlabel = findLang(language, key,'zh-CN') || (object.displayReference && object.displayReference.label)
        let enlabel = findLang(language, key,'en-US') || (object.displayReference && object.displayReference.label)
        let type = elementType
        let spList = JSON.parse(JSON.stringify(spaceList))
        let nextSpList = JSON.parse(JSON.stringify(spaceList))
        let visible = true
        if(object.displayReference){
            visible = object.displayReference.visible
        }

        let value = findValue(keypath + "." + key, datamodel)
        
        let exist = existList.filter((item: string) => {
            return (keypath + '.' + key).startsWith(item)
        })

        if(exist.length && exist.length > 0) {
            return undefined
        }

        const spaceObj = new TemplateSpaceObject(type, key, keypath, zhlabel, enlabel, visible, value, spList)
        nextSpList.push(spaceObj)

        let attributes = object.dataReference.attributes
        if(!attributes || attributes.length <= 0){
            let remoteElement = findTemplate(templateJson, object.type)

            if(remoteElement || preContainerList.includes(elementType)){
                let keypath = spList.map((item: any)=>{ return item.key }).join('.')
                let key = object.key || ""
                let visible = object.displayReference.visible
                let zhlabel = remoteElement.name
                let enlabel = remoteElement.name
                let type = elementType
                let nextSpList = JSON.parse(JSON.stringify(spaceList))
                let value;
                if(listValue != undefined) {
                    value = listValue
                }else{
                    value = findValue(keypath + "." + key, datamodel)
                }

                return new TemplateSpaceObject(type, key, keypath, zhlabel, enlabel, visible, value, nextSpList)
            }
        }else{

            let value = undefined
            
            value = attributes.map((item: any) => {
                let elementValue = undefined
                if(listValue){
                    elementValue = listValue[item.key]
                }
                return mapElement(item,nextSpList, config, elementValue)
            })
            value = value.filter((item: any) => {
                return item != undefined
            })

            return new TemplateSpaceObject(type, key, keypath, zhlabel, enlabel, visible, value, spList)
        }
    }
}
/**
 * 
 * @param  keypath find key path
 * @param  datamodel datamodel
 * @returns value
 */
const findValue = (keypath: string, datamodel: any) => {

    let totalKeypath = keypath
    let keypathList = totalKeypath.split('.')

    let obj = datamodel[keypathList[0]]
    for (let index = 1; index < keypathList.length; index++) {
        const element = keypathList[index];
        if(isObject(obj)){
            obj = obj[element]
        } else if (isArray(obj)){
            /// 数组嵌套
            let listObj = obj[0]
            obj = listObj
        }
    }

    return obj
}

/**
 * @param templateJson  template
 * @param depth 校验深度
 * @param existList 既有已解析list
 * @returns 待处理, 待渲染元素对象
 */
export const checkTemplete = (templateJson: any, depth: number, existList: Array<string>, datamodel: any) => {

    let formattedTemplateResult = formatterTemplate(templateJson)
    let objList = formattedTemplateResult.filter((item: TemplateSpaceObject) => {
        return item.spaceList.length <= depth
    })

    const notRenderedElements = objList.filter((item: TemplateSpaceObject) => {
        let completeKeypath = item.keypath + '.' + item.key
        return !existList.includes(completeKeypath)
    })

    let result = notRenderedElements.map((item: TemplateSpaceObject) => {

        let totalKeypath: string = item.keypath + '.' + item.key
        let keypathList = totalKeypath.split('.')

        let obj = datamodel[keypathList[0]]
        for (let index = 1; index < keypathList.length; index++) {
            const element = keypathList[index];
            if(isObject(obj)){
                obj = obj[element]
            } else if (isArray(obj)){
                /// 数组嵌套
                let listObj = obj[0]
                obj = listObj
            }
        }
        item.value = obj
        return item
    })

    return result
}